import React, { useState, useEffect } from 'react';
import '../App.css';

function ScheduleViewer() {
  const [schedules, setSchedules] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(1);
  const [loading, setLoading] = useState(true);

  const monthNames = ['', 'January', 'February', 'March', 'April', 'May', 'June',
                     'July', 'August', 'September', 'October', 'November', 'December'];

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    try {
      setLoading(true);
      const res = await fetch('https://storypublisher.onrender.com/schedules');
      const data = await res.json();
      setSchedules(data);
    } catch (err) {
      console.error('Error loading schedules:', err);
    } finally {
      setLoading(false);
    }
  };

  const currentSchedule = schedules.find(s => s.month === selectedMonth);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Monthly Schedules</h2>
      
      {loading ? (
        <p>Loading schedules...</p>
      ) : (
        <>
          {/* Month selector buttons */}
          <div style={{ marginBottom: '20px', display: 'flex', flexWrap: 'wrap', gap: '5px', justifyContent: 'center' }}>
            {monthNames.slice(1).map((name, idx) => {
              const month = idx + 1;
              const hasSchedule = schedules.some(s => s.month === month);
              return (
                <button
                  key={month}
                  onClick={() => setSelectedMonth(month)}
                  style={{
                    padding: '8px 12px',
                    backgroundColor: selectedMonth === month ? '#4CAF50' : (hasSchedule ? '#2196F3' : '#ccc'),
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: hasSchedule || selectedMonth === month ? 'pointer' : 'not-allowed',
                    fontSize: '12px',
                    fontWeight: selectedMonth === month ? 'bold' : 'normal',
                    opacity: hasSchedule ? 1 : 0.6,
                  }}
                  disabled={!hasSchedule && selectedMonth !== month}
                >
                  {name.substring(0, 3)}
                </button>
              );
            })}
          </div>

          {/* Display selected schedule */}
          <div style={{ marginTop: '30px' }}>
            <h3>{monthNames[selectedMonth]}</h3>
            {currentSchedule && currentSchedule.imagePath ? (
              <div style={{ marginTop: '20px' }}>
                <img 
                  src={currentSchedule.imagePath} 
                  alt={`${monthNames[selectedMonth]} Schedule`}
                  style={{ maxWidth: '100%', maxHeight: '600px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}
                />
              </div>
            ) : (
              <p style={{ color: '#666', marginTop: '20px' }}>No schedule available for {monthNames[selectedMonth]}</p>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default ScheduleViewer;
